import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams, SagaGenericParams } from "src/request/types";
import * as Type from "./type";

export const getSectorListSaga = createAction(
  "GET_SECTOR",
  ({ payload, params }: SagaActionParams<Type.SectorDto[]>) => ({
    payload,
    url: "/api/admin/sectors" + (params ? params : ""),
  })
);
export const getSectorDetailsSaga = createAction(
  "GET_SECTOR_DETAILS",
  ({ payload, id }: SagaActionParams<Type.SectorDetailDto>) => ({
    payload,
    url: "/api/admin/sectors/" + id,
  })
);
export const createSectorSaga = createAction(
  "CREATE_SECTOR",
  ({ payload, body }: SagaActionParams<Type.SectorDto>) => ({
    payload,
    url: "/api/admin/sectors",
    body,
  })
);
export const updateSectorSaga = createAction(
  "UPDATE_SECTOR",
  ({ payload, id, body }: SagaActionParams<Type.SectorDto>) => ({
    payload,
    url: "/api/admin/sectors/" + id,
    body,
  })
);
export const deleteSectorSaga = createAction(
  "DELETE_SECTOR",
  ({ payload, id }: SagaActionParams<Type.SectorDto>) => ({
    payload,
    url: "/api/admin/sectors/" + id,
  })
);

const sectorsSaga = [
  takeLatest<any>(
    getSectorListSaga.toString(),
    (payload: SagaGenericParams<Type.SectorDto[]>) =>
      getSaga<Type.SectorDto[]>(payload)
  ),
  takeLatest<any>(
    getSectorDetailsSaga.toString(),
    (payload: SagaGenericParams<Type.SectorDetailDto>) =>
      getSaga<Type.SectorDetailDto>(payload)
  ),
  takeLatest<any>(
    createSectorSaga.toString(),
    (payload: SagaGenericParams<Type.SectorDto>) =>
      postSaga<Type.SectorDto>(payload)
  ),
  takeLatest<any>(
    updateSectorSaga.toString(),
    (payload: SagaGenericParams<Type.SectorDto>) =>
      putSaga<Type.SectorDto>(payload)
  ),
  takeLatest<any>(
    deleteSectorSaga.toString(),
    (payload: SagaGenericParams<any>) => deleteSaga<Type.SectorDto>(payload)
  ),
];

export default sectorsSaga;
